import { useSelector } from 'react-redux'
import { Modal } from 'antd'

import { selectTranslate } from '../../../reducers/LocaleReducer/LocalReducer'
import ConfirmFormFooter from '../../../Components/antd/Forms/ConfirmFormFooter'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTriangleExclamation } from '@fortawesome/pro-duotone-svg-icons'

export const RedirectActions = Object.freeze({
  REDIRECTION: 'REDIRECT',
  WITH_REMINDER: 'WITH_REMINDER'
})

const CONFIRM_BUTTON_TITLE = 'redirect_student_modal.confirm.title'

const RedirectStudentModal = ({ redirectAction, onCancel, onConfirm }) => {
  const t = useSelector(selectTranslate)

  return (
    <Modal
      centered
      footer={(
        <ConfirmFormFooter
          confirmTitle={t(CONFIRM_BUTTON_TITLE)}
          cancelTitle={t('redirect_student_modal.cancel.title')}
          confirmClassName='logo-colored-button blue-ghost blue-hover'
          cancelClassName='logo-colored-button gray-ghost gray-hover'
          onCancel={onCancel}
          onConfirm={onConfirm}
        />
      )}
      title={t('redirect_student_modal.title')}
      visible={redirectAction.length > 0}
      onCancel={onCancel}
    >
      <>
        <p>{t('redirect_student_modal.email_already_taken')}</p>
        <p>{t('redirect_student_modal.question')}</p>

        {redirectAction === RedirectActions.REDIRECTION && (
          <span>{t('redirect_student_modal.redirect.call_to_action', { buttonTitle: t(CONFIRM_BUTTON_TITLE) })}</span>
        )}

        {redirectAction === RedirectActions.WITH_REMINDER && (
          <div className='mt-12 mb-12 modal-inner-container warning flex-row ai-ctr'>
            <FontAwesomeIcon
              icon={faTriangleExclamation}
              color='goldenrod'
              style={{
                marginLeft: '4px',
                marginTop: '2px',
                alignSelf: 'flex-start'
              }}
            />
            <div className='ml-8'>
              <p>{t('redirect_student_modal.with_reminder.account_explanation')}</p>
              <span>{t('redirect_student_modal.with_reminder.email_explanation', { buttonTitle: t(CONFIRM_BUTTON_TITLE) })}</span>
              <br />
            </div>
          </div>
        )}

        <p>{t('redirect_student_modal.final.explanation')}</p>
        <span>{t('redirect_student_modal.final.call_to_action')}</span>
      </>
    </Modal>
  )
}

export default RedirectStudentModal
